module.exports = __webpack_public_path__ + "fonts/visuelt-pro-bold.a6c5051b.woff2";